import { Component } from '@angular/core';

@Component({
	selector: 'app-icon-buttons',
	templateUrl: './icon-buttons.component.html',
	styleUrls: ['./icon-buttons.component.scss'],
	standalone: false,
})
export class IconButtonsComponent {
	onButtonClick(buttonName: string): void {
		console.log(`Custom button clicked: ${buttonName}`);
	}
}
